/**
 * AI PC 新品速递页面交互脚本
 */
var campaignPageAiPcNewArrivalModule = {
    /**
     * 初始化
     */
    init: function() {

        // this.initBanner();
        this.initCategoryTabs();
        this.initSubCategoryTabs();
        this.initFourthCategoryTabs(); // 初始化第四层分类标签（工作站）
        this.initRightCards();
        this.initProductCardEvents();
        this.initInitialProducts();
        this.initMobileCompatibility();
        this.initServerProductModule();
        this.initRightNavigationButtons();
    },

    /**
     * 初始化初始产品列表
     */
    initInitialProducts: function() {
        var _this = this;

        // 等待 DOM 完全加载后再初始化
        setTimeout(function() {
            // 获取所有产品容器
            var allContainers = document.querySelectorAll('.products-container-bg');

            allContainers.forEach(function(container) {
                var categoryId = container.getAttribute('data-category-id');
                var categoryTitle = container.getAttribute('data-category-title');
                var categoryData = _this.getCategoryData(categoryId);

                if (categoryData) {
                    // 跳过服务器和存储产品（使用静态展示）
                    if (categoryData.title === '服务器' || categoryData.title === '存储产品') {
                        return;
                    }

                    // 获取第一个子分类
                    var firstSubCategoryId = null;

                    if (categoryData.sub_categories && categoryData.sub_categories.length > 0) {
                        firstSubCategoryId = categoryData.sub_categories[0].id;
                    }

                    // 渲染初始产品列表
                    if (firstSubCategoryId) {
                        // 判断是否为工作站分类
                        if (categoryTitle === '工作站') {
                            // 工作站：更新第四层分类标签
                            _this.updateFourthCategoryTabs(container, firstSubCategoryId);
                        } else {
                            // 非工作站：直接更新产品列表
                            _this.updateProductsBySubCategory(container, firstSubCategoryId);
                        }
                    }
                }
            });
        }, 100);
    },

    /**
     * 初始化产品分类标签切换（锚点跳转）
     */
    initCategoryTabs: function() {
        var _this = this;
        var tabs = document.querySelectorAll('.category-tabs .tab-item');

        if (!tabs.length) return;

        tabs.forEach(function(tab) {
            tab.addEventListener('click', function() {
                var categoryId = this.getAttribute('data-category-id');
                var categoryTitle = this.getAttribute('data-category-title');
                var targetId = this.getAttribute('data-target');

                // 移除所有标签的 active 状态
                tabs.forEach(function(t) {
                    t.classList.remove('active');
                });

                // 为当前标签添加 active 状态
                this.classList.add('active');

                // 根据分类标题判断跳转目标
                var targetContainer = null;

                if (categoryTitle === '服务器') {
                    // 服务器跳转到 PowerEdge 服务器区域
                    targetContainer = document.getElementById('poweredge-server-section');
                } else if (categoryTitle === '存储产品') {
                    // 存储产品跳转到存储区域
                    targetContainer = document.getElementById('storage-section');
                } else {
                    // 其他分类跳转到对应的产品容器
                    targetContainer = document.getElementById(targetId);
                }

                if (targetContainer) {
                    // 获取导航栏高度（如果有固定导航栏，假设类名为 .header 或具体高度，这里减去约 80px 作为缓冲）
                    var headerOffset = 120;
                    var elementPosition = targetContainer.getBoundingClientRect().top;
                    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    // 平滑滚动到目标区域并减去导航高度
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth"
                    });

                    // 记录用户行为
                    _this.trackCategoryClick(categoryId, categoryTitle);
                }
            });
        });
    },

    /**
     * 初始化子分类标签切换
     */
    initSubCategoryTabs: function() {
        var _this = this;

        // 为所有子分类标签添加点击事件
        var subCategoryContainers = document.querySelectorAll('.sub-category-tabs');

        subCategoryContainers.forEach(function(container) {
            var subTabs = container.querySelectorAll('.sub-tab-item');

            subTabs.forEach(function(subTab) {
                subTab.addEventListener('click', function() {
                    var subCategoryId = this.getAttribute('data-sub-category-id');
                    var subCategoryTitle = this.getAttribute('data-sub-category-title');

                    // 移除当前容器内所有子标签的 active 状态
                    subTabs.forEach(function(t) {
                        t.classList.remove('active');
                    });

                    // 为当前标签添加 active 状态
                    this.classList.add('active');

                    // 记录用户行为
                    _this.trackSubCategoryClick(subCategoryId, subCategoryTitle);

                    // 获取当前的产品容器
                    var productsContainer = container.closest('.products-container-bg');
                    if (productsContainer) {
                        var categoryTitle = productsContainer.getAttribute('data-category-title');

                        // 判断是否为工作站分类
                        if (categoryTitle === '工作站') {
                            // 工作站：更新第四层分类标签
                            _this.updateFourthCategoryTabs(productsContainer, subCategoryId);
                        } else {
                            // 非工作站：直接更新产品列表
                            _this.updateProductsBySubCategory(productsContainer, subCategoryId);
                        }
                    }
                });
            });
        });
    },

    /**
     * 初始化第四层分类标签切换（仅工作站）
     */
    initFourthCategoryTabs: function() {
        var _this = this;

        // 为所有第四层分类标签添加点击事件
        var fourthCategoryContainers = document.querySelectorAll('.fourth-category-tabs');

        fourthCategoryContainers.forEach(function(container) {
            var fourthTabs = container.querySelectorAll('.fourth-tab-item');

            fourthTabs.forEach(function(fourthTab) {
                fourthTab.addEventListener('click', function() {
                    var fourthCategoryId = this.getAttribute('data-fourth-category-id');

                    // 移除当前容器内所有子标签的 active 状态
                    fourthTabs.forEach(function(t) {
                        t.classList.remove('active');
                    });

                    // 为当前标签添加 active 状态
                    this.classList.add('active');

                    // 记录用户行为
                    var fourthCategoryTitle = this.textContent.trim();
                    _this.trackFourthCategoryClick(fourthCategoryId, fourthCategoryTitle);

                    // 获取当前的产品容器
                    var productsContainer = container.closest('.products-container-bg');
                    if (productsContainer) {
                        // 更新产品列表
                        _this.updateProductsByFourthCategory(productsContainer, fourthCategoryId);
                    }
                });
            });
        });
    },

    /**
     * 初始化产品卡片事件
     */
    initProductCardEvents: function() {
        var _this = this;

        // 3D 展示按钮
        var btn3dList = document.querySelectorAll('.btn-3d');
        btn3dList.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var link3d = this.getAttribute('data-3d-link');
                if (link3d) {
                    window.open(link3d, '_blank');
                }

                var card = this.closest('.product-card');
                if (card) {
                    var productTitle = card.querySelector('.product-name');
                    var titleText = productTitle ? productTitle.textContent.trim() : '';

                    // 获取当前分类
                    var activeTab = document.querySelector('.category-tabs .tab-item.active');
                    var categoryText = activeTab ? activeTab.textContent.trim() : '';

                    _this.track3DViewClick('', titleText, categoryText);
                }
            });
        });

        // 立即选购按钮
        var btnBuyList = document.querySelectorAll('.btn-buy');
        btnBuyList.forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var productUrl = this.getAttribute('data-url');
                if (productUrl) {
                    window.open(productUrl, '_blank');
                }

                var card = this.closest('.product-card');
                if (card) {
                    var productTitle = card.querySelector('.product-name');
                    var titleText = productTitle ? productTitle.textContent.trim() : '';

                    // 获取当前分类
                    var activeTab = document.querySelector('.category-tabs .tab-item.active');
                    var categoryText = activeTab ? activeTab.textContent.trim() : '';

                    _this.trackProductClick('', titleText, categoryText);
                }
            });
        });
    },

    /**
     * 初始化 Banner 轮播
     */
    initBanner: function() {
        var bannerContainer = document.querySelector('.banner-box .swiper-container');
        if (!bannerContainer) return;

        new Swiper(bannerContainer, {
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            }
        });
    },

    /**
     * 初始化超级权益卡片点击跳转
     */
    initRightCards: function() {
        var _this = this;
        var rightCards = document.querySelectorAll('.right-card');

        if (!rightCards.length) return;

        rightCards.forEach(function(card) {
            card.addEventListener('click', function(e) {
                var url = this.getAttribute('data-url');
                if (url) {
                    window.open(url, '_blank');
                    _this.trackRightCardClick(this);
                }
            });
        });
    },

    /**
     * 记录超级权益卡片点击事件
     */
    trackRightCardClick: function(card) {
        var title = card.querySelector('h3');
        var titleText = title ? title.textContent.trim() : '';

        // gio PowerFlextab_click 埋点
        var adSlot = card.getAttribute('data-ad-slot') || titleText;
        if (typeof gio !== 'undefined') {
            gio('track', 'PowerFlextab_click', {
                'NewProduct_AdSlot': adSlot
            });
        }

        if (typeof window.cateData !== 'undefined' && window.cateData.userRecodeOption) {
            window.cateData.userRecodeOption.category3 = titleText;
        }
    },

    /**
     * 记录分类点击事件
     */
    trackCategoryClick: function(categoryId, categoryName) {

        // gio PowerFlextab_click 埋点
        if (typeof gio !== 'undefined') {
            gio('track', 'PowerFlextab_click', {
                'FilesTitle_Fifth': categoryName
            });
        }

        // 记录到 cateData（如果可用）
        if (typeof window.cateData !== 'undefined' && window.cateData.userRecodeOption) {
            window.cateData.userRecodeOption.category2 = categoryName;
        }
    },

    /**
     * 记录子分类点击事件
     */
    trackSubCategoryClick: function(subCategoryId, subCategoryName) {
        // gio PowerFlextab_click 埋点
        if (typeof gio !== 'undefined') {
            gio('track', 'PowerFlextab_click', {
                'productname': subCategoryName
            });
        }

        // 记录到 cateData（如果可用）
        if (typeof window.cateData !== 'undefined' && window.cateData.userRecodeOption) {
            window.cateData.userRecodeOption.category3 = subCategoryName;
        }
    },

    /**
     * 记录第四层分类点击事件（工作站）
     */
    trackFourthCategoryClick: function(fourthCategoryId, fourthCategoryName) {
        // gio PowerFlextab_click 埋点
        if (typeof gio !== 'undefined') {
            gio('track', 'PowerFlextab_click', {
                'productname': fourthCategoryName
            });
        }

        // 记录到 cateData（如果可用）
        if (typeof window.cateData !== 'undefined' && window.cateData.userRecodeOption) {
            window.cateData.userRecodeOption.category4 = fourthCategoryName;
        }
    },

    /**
     * 移动端兼容性处理
     */
    initMobileCompatibility: function() {
        // 在小程序环境中显示底部导航
        if (typeof common !== 'undefined' && common.isFromXCX && common.isFromXCX()) {
            var bottomBox = document.querySelector('.bottombox');
            var bottomNav = document.querySelector('.bottomnav');
            var mainContainer = document.querySelector('.campaign-page-module-ai-pc-new-arrival .ai-pc-new-arrival-container');

            if (bottomBox) bottomBox.style.display = 'block';
            if (bottomNav) bottomNav.style.display = 'none';
            if (mainContainer) mainContainer.style.paddingBottom = '1.8rem';
        }
    },

    /**
     * 替换右侧公共导航按钮
     */
    initRightNavigationButtons: function() {
        var _this = this;

        setTimeout(function() {
            var bottomIT = document.querySelector('.bottomIT');
            if (bottomIT) {
                var links = bottomIT.querySelectorAll('a');
                if (links.length >= 2) {
                    links[0].href = 'https://smarket.dellemc-solution.com/u/HqH2I3';
                    links[0].onclick = function() {
                        if (typeof common !== 'undefined' && !common.isLogin()) {
                            common.gotoLogin();
                            return false;
                        }
                        if (typeof gioTrackAction !== 'undefined' && gioTrackAction.gio_base) {
                            gioTrackAction.gio_base('eshopRNavigation_Solution_Click');
                        }
                    };
                    var img1 = links[0].querySelector('img');
                    if (img1) {
                        img1.src = '/static/pc/img/campaign/ai-pc-new-arrival/新品定制解决方案.png';
                    }

                    links[1].href = 'https://www.dellemc-solution.com/u/pfvxkty';
                    links[1].onclick = function() {
                        if (typeof gioTrackAction !== 'undefined' && gioTrackAction.gio_base) {
                            gioTrackAction.gio_base('eshopRNavigation_Subscribe_Click');
                        }
                    };
                    var img2 = links[1].querySelector('img');
                    if (img2) {
                        img2.src = 'https://www.dellemc-solution.com/campaigns/xcx_images/dell-solution-services-miniprogram/ai-pc-new-arrival/new-product-tester-btn.png';
                    }
                }
            }
        }, 100);
    },

    /**
     * 更新子分类标签
     */
    updateSubCategoryTabs: function(container, subCategories) {
        var subCategoryTabsContainer = container.querySelector('.sub-category-tabs');
        if (!subCategoryTabsContainer) return;

        // 清空现有的子分类标签
        subCategoryTabsContainer.innerHTML = '';

        // 生成新的子分类标签
        subCategories.forEach(function(subCategory, index) {
            var isActive = index === 0 ? 'active' : '';
            var tabHtml = '<div class="sub-tab-item ' + isActive + '" data-sub-category-id="' + subCategory.id + '">' +
                subCategory.title +
                '</div>';
            subCategoryTabsContainer.insertAdjacentHTML('beforeend', tabHtml);
        });

        // 重新绑定子分类点击事件
        this.initSubCategoryTabs();
    },

    /**
     * 根据子分类更新产品列表
     */
    updateProductsBySubCategory: function(container, subCategoryId) {
        var _this = this;

        if (!container) return;

        // 获取当前分类的数据
        var categoryId = container.getAttribute('data-category-id');
        var categoryData = this.getCategoryData(categoryId);
        if (!categoryData) return;

        // 获取产品数据
        var products = [];

        // 直接从子分类获取产品
        products = this.getSubCategoryProducts(categoryData, subCategoryId);

        // 更新产品展示区域
        this.renderProducts(container, products, categoryData.title);
    },

    /**
     * 更新第四层分类标签（工作站）
     */
    updateFourthCategoryTabs: function(container, subCategoryId) {
        var subCategoryTabsContainer = container.querySelector('.fourth-category-tabs');
        if (!subCategoryTabsContainer) return;

        // 获取当前分类的数据
        var categoryId = container.getAttribute('data-category-id');
        var categoryData = this.getCategoryData(categoryId);
        if (!categoryData) return;

        // 获取第三层子分类数据
        var subCategory = this.getSubCategoryById(categoryData, subCategoryId);
        if (!subCategory || !subCategory.sub_categories) return;

        var fourthCategories = subCategory.sub_categories;

        // 清空现有的第四层分类标签
        subCategoryTabsContainer.innerHTML = '';
        // 移除初始化标记，允许重新初始化滑动功能
        subCategoryTabsContainer.removeAttribute('data-slider-initialized');

        // 生成新的第四层分类标签（包含导航按钮和容器）
        var _this = this;

        // 判断是否少于等于2个，添加对应类名
        if (fourthCategories.length <= 2) {
            subCategoryTabsContainer.classList.add('show-less-than-3');
        } else {
            subCategoryTabsContainer.classList.remove('show-less-than-3');
        }

        // 生成完整的HTML结构
        var tabsHtml = '<div class="fourth-category-nav-btn fourth-category-prev">' +
            '<img src="/static/pc/img/campaign/ai-pc-new-arrival/arrow-left-gray.svg" alt="上一个">' +
            '</div>' +
            '<div class="fourth-category-tabs-container">' +
            '<div class="fourth-category-tabs-inner">';

        fourthCategories.forEach(function(fourthCategory, index) {
            var isActive = index === 0 ? 'active' : '';
            tabsHtml += '<div class="fourth-tab-item ' + isActive + '" data-fourth-category-id="' + fourthCategory.id + '" data-fourth-category-title="' + fourthCategory.title + '">' +
                fourthCategory.title +
                '</div>';
        });

        tabsHtml += '</div></div>' +
            '<div class="fourth-category-nav-btn fourth-category-next">' +
            '<img src="/static/pc/img/campaign/ai-pc-new-arrival/arrow-right-gray.svg" alt="下一个">' +
            '</div>';

        subCategoryTabsContainer.innerHTML = tabsHtml;

        // 重新初始化第四层分类滑动功能（导航按钮、禁用状态、点击切换）
        if (typeof initFourthCategoryTabsSlider === 'function') {
            initFourthCategoryTabsSlider();
        }

        // 重新绑定第四层分类点击事件
        this.initFourthCategoryTabs();

        // 渲染第一个第四层分类的产品
        if (fourthCategories.length > 0) {
            this.updateProductsByFourthCategory(container, fourthCategories[0].id);
        }
    },

    /**
     * 根据第四层分类更新产品列表（工作站）
     */
    updateProductsByFourthCategory: function(container, fourthCategoryId) {
        var _this = this;

        if (!container) return;

        // 获取当前分类的数据
        var categoryId = container.getAttribute('data-category-id');
        var categoryData = this.getCategoryData(categoryId);
        if (!categoryData) return;

        // 获取产品数据
        var products = [];

        // 从第四层分类获取产品
        products = this.getFourthCategoryProducts(categoryData, fourthCategoryId);

        // 更新产品展示区域
        this.renderProducts(container, products, categoryData.title);
    },

    /**
     * 获取分类数据
     */
    getCategoryData: function(categoryId) {
        if (typeof window.productsData === 'undefined' || !window.productsData) return null;

        try {
            var productsData = window.productsData;
            return productsData.find(function(cat) {
                return cat.id == categoryId;
            });
        } catch (e) {
            console.error('解析产品数据失败:', e);
            return null;
        }
    },

    /**
     * 获取子分类的产品列表（非台式机/一体机）
     */
    getSubCategoryProducts: function(categoryData, subCategoryId) {
        if (!categoryData.sub_categories) {
            console.log('该分类没有子分类');
            return [];
        }

        var subCategory = categoryData.sub_categories.find(function(sub) {
            return sub.id == subCategoryId;
        });

        if (!subCategory) {
            return [];
        }

        if (!subCategory.products) {
            return [];
        }

        return subCategory.products;
    },

    /**
     * 根据ID获取第三层子分类数据
     */
    getSubCategoryById: function(categoryData, subCategoryId) {
        if (!categoryData.sub_categories) return null;

        return categoryData.sub_categories.find(function(sub) {
            return sub.id == subCategoryId;
        });
    },

    /**
     * 获取第四层子分类的产品列表（工作站）
     */
    getFourthCategoryProducts: function(categoryData, fourthCategoryId) {
        if (!categoryData.sub_categories) return [];

        // 遍历第三层子分类
        for (var i = 0; i < categoryData.sub_categories.length; i++) {
            var subCategory = categoryData.sub_categories[i];
            if (subCategory.sub_categories) {
                // 在第四层分类中查找（使用 == 进行宽松比较，兼容字符串和数字类型）
                var fourthCategory = subCategory.sub_categories.find(function(fourth) {
                    return fourth.id == fourthCategoryId;
                });
                if (fourthCategory) {
                    console.log('找到第四层分类:', fourthCategory.title, '产品数量:', fourthCategory.products ? fourthCategory.products.length : 0);
                    if (fourthCategory.products) {
                        return fourthCategory.products;
                    }
                }
            }
        }

        console.log('未找到第四层分类，ID:', fourthCategoryId);
        return [];
    },

    /**
     * 渲染产品列表（纵向显示，支持展开/收起）
     */
    renderProducts: function(container, products, categoryTitle) {
        var productsSection = container.querySelector('.products-section');
        if (!productsSection) return;

        // 清空现有产品卡片及容器（保留 teaser 卡片）
        var existingCards = productsSection.querySelectorAll('.product-detail-card');
        existingCards.forEach(function(card) {
            card.remove();
        });
        var existingSwiper = productsSection.querySelector('.products-swiper-container');
        if (existingSwiper) {
            if (existingSwiper.swiperInstance) {
                existingSwiper.swiperInstance.destroy(true, true);
            }
            existingSwiper.remove();
        }
        var existingList = productsSection.querySelector('.products-list-container');
        if (existingList) {
            existingList.remove();
        }
        var existingToggle = productsSection.querySelector('.products-toggle-btn');
        if (existingToggle) {
            existingToggle.remove();
        }
        var existingNext = productsSection.querySelector('.custom-swiper-next');
        if (existingNext) {
            existingNext.remove();
        }
        var existingPrev = productsSection.querySelector('.custom-swiper-prev');
        if (existingPrev) {
            existingPrev.remove();
        }

        // 如果没有产品，显示提示
        if (!products || products.length === 0) {
            var noProductsHtml = '<div class="no-products-tip">暂无产品数据</div>';
            productsSection.insertAdjacentHTML('beforeend', noProductsHtml);
            return;
        }

        var _this = this;
        var productsCount = products.length;
        var showToggle = productsCount > 3;

        // 渲染产品卡片
        var cardsHtml = '<div class="products-list-container" data-total-count="' + productsCount + '">';

        products.forEach(function(product, index) {
            // 默认只显示前3个，其他的添加隐藏类
            var isHidden = showToggle && index >= 3 ? ' style="display: none;"' : '';
            cardsHtml += '<div class="product-slide-item"' + isHidden + '>' + _this.buildProductCardHtml(product, categoryTitle) + '</div>';
        });

        cardsHtml += '</div>';
        productsSection.insertAdjacentHTML('beforeend', cardsHtml);

        // 如果产品超过3个，添加展开/收起按钮
        if (showToggle) {
            var toggleBtnHtml = '<div class="products-toggle-btn" data-expanded="false">' +
                '<span class="toggle-text">展开全部</span>' +
                '<span class="toggle-icon">⌵</span>' +
                '</div>';
            productsSection.insertAdjacentHTML('beforeend', toggleBtnHtml);

            // 绑定展开/收起按钮事件
            var toggleBtn = productsSection.querySelector('.products-toggle-btn');
            if (toggleBtn) {
                toggleBtn.addEventListener('click', function() {
                    _this.toggleProducts(this, productsSection);
                });
            }
        }

        // 重新绑定产品卡片事件
        this.initProductCardEvents();
    },

    /**
     * 展开/收起产品列表
     */
    toggleProducts: function(toggleBtn, productsSection) {
        var isExpanded = toggleBtn.getAttribute('data-expanded') === 'true';
        var productsList = productsSection.querySelector('.products-list-container');
        var productItems = productsList.querySelectorAll('.product-slide-item');
        var toggleText = toggleBtn.querySelector('.toggle-text');
        var toggleIcon = toggleBtn.querySelector('.toggle-icon');

        if (!isExpanded) {
            // 展开：显示所有产品
            productItems.forEach(function(item) {
                item.style.display = 'block';
            });
            toggleText.textContent = '收起';
            toggleIcon.textContent = '⌃';
            toggleBtn.setAttribute('data-expanded', 'true');
        } else {
            // 收起：只显示前3个产品
            productItems.forEach(function(item, index) {
                if (index >= 3) {
                    item.style.display = 'none';
                }
            });
            toggleText.textContent = '展开全部';
            toggleIcon.textContent = '⌵';
            toggleBtn.setAttribute('data-expanded', 'false');

            // 滚动到产品列表顶部
            productsList.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    },

    /**
     * 构建产品卡片 HTML
     */
    buildProductCardHtml: function(product, categoryTitle) {
        var productId = product.id || '';
        var productTitle = product.title || '';
        // 判断标题中是否包含<br/>，如果有的话，去掉它
        // productTitle = productTitle.replace(/<br\/>/g, '');
        var coverImage = product.cover_image || '/static/pc/img/campaign/ai-pc-new-arrival/product-11.png';
        var summary = product.summary || '';
        var type1 = product.type1 || '';
        var type2 = product.type2 || '';
        var tag = product.tag || '';
        var link3d = product['3d_link'] || '';
        var productUrl = product.url || '';

        var premiumLabelHtml = type1 ? '<div class="premium-label">' + type1 + '</div>' : '';

        var priceTagsHtml = '';
        if (tag || type2) {
            priceTagsHtml = '<div class="price-tags">';
            if (tag) {
                priceTagsHtml += '<span class="tag-orange"><span class="tag-text">' + tag + '</span></span>';
            }
            if (type2) {
                priceTagsHtml += '<span class="tag-black">' + type2 + '</span>';
            }
            priceTagsHtml += '</div>';
        }

        var specsListHtml = '';
        if (summary) {
            var specs = summary.split('***');
            specsListHtml = '<ul class="specs-list">';
            specs.forEach(function(spec) {
                spec = spec.trim();
                if (spec) {
                    specsListHtml += '<li>' + spec + '</li>';
                }
            });
            specsListHtml += '</ul>';
        }

        var titleHtml = productUrl ?
            '<a href="' + productUrl + '" class="product-name" target="_blank">' + productTitle + '</a>' :
            '<span class="product-name">' + productTitle + '</span>';

        var btn3dHtml = link3d ?
            '<div class="action-btn btn-3d" data-3d-link="' + link3d + '">' +
            '<img src="/static/pc/img/campaign/ai-pc-new-arrival/3d-icon.svg" alt=""> 3D 展示' +
            '</div>' : '';

        var btnBuyHtmlWap = productUrl ?
            '<div class="action-btn btn-buy" data-url="' + productUrl + '">立即选购</div>': 
            '<div class="action-btn btn-buy" onclick="msg.ProjectConsultingDialog()">立即选购</div>';

        var htmlWap =
            '<div class="product-card product-detail-card" data-product-id="' + productId + '">' +
            '<div class="product-card-content">' +
            '<div class="product-top">' +
            titleHtml +
            '<div class="product-info">' +
            specsListHtml +
            priceTagsHtml +
            // premiumLabelHtml +
            '</div>' +
            '</div>' +
            '<div class="product-header">' +
            '<div class="product-image">' +
            '<img src="' + coverImage + '" alt="' + productTitle + '" style="width: 100%; height: 100%; object-fit: contain;">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div class="product-footer-box">' +
            '<div class="product-actions">' +
            btn3dHtml +
            btnBuyHtmlWap +
            '</div>' +
            '<div class="member-banner">' +
            '<div class="banner-text">一键加入会员 <br>享<span>免费抽奖</span>和<span>0元试用</span></div>' +
            '<img src="/static/pc/img/campaign/ai-pc-new-arrival/gift-icon-wap.png" class="gift-icon" alt="gift">' +
            '</div>' +
            '<div class="coupon-link">联系客服<br>领千元优惠券</div>' +
            '</div>' +
            '</div>';

        
        return htmlWap;
    },

    /**
     * 记录产品点击事件
     */
    trackProductClick: function(productId, productTitle, categoryTitle) {
        if (typeof gioTrackAction !== 'undefined' && gioTrackAction.navGioEvent) {
            gioTrackAction.navGioEvent(
                'AI PC 新品速递',
                categoryTitle,
                '查看产品详情',
                productTitle,
                false
            );
        }
    },

    /**
     * 记录 3D 展示点击事件
     */
    track3DViewClick: function(productId, productTitle, categoryTitle) {
        if (typeof gioTrackAction !== 'undefined' && gioTrackAction.navGioEvent) {
            gioTrackAction.navGioEvent(
                'AI PC 新品速递',
                categoryTitle,
                '3D展示',
                productTitle,
                false
            );
        }
    },

    /**
     * 初始化服务器产品模块
     */
    initServerProductModule: function() {
        var _this = this;
        var serverButtons = document.querySelectorAll('.product-button');

        if (!serverButtons.length) return;

        serverButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                var url = this.getAttribute('data-url');
                if (url) {
                    window.open(url, '_blank');
                    _this.trackServerProductClick(this);
                }
            });
        });
    },

    trackServerProductClick: function(card) {
        var title = card.parentElement.querySelector('h3');
        var titleText = title ? title.textContent.trim() : '';
        var text = card.getAttribute('data-text');
        if (typeof gioTrackAction !== 'undefined' && gioTrackAction.navGioEvent) {
            gioTrackAction.navGioEvent(
                'AI PC 新品速递',
                titleText,
                text,
                titleText,
                false
            );
        }

        if (typeof window.cateData !== 'undefined' && window.cateData.userRecodeOption) {
            window.cateData.userRecodeOption.category3 = titleText;
        }
    },
};

// 初始化 Vue 实例以支持 subscribe-dialog 组件
campaignPageAiPcNewArrivalModule.initVue = function() {
    if (typeof Vue !== 'undefined') {
        new Vue({
            el: '.template-acq-content-box',
            data: {},
            mounted: function() {
                // Vue 初始化完成
            }
        });
    }
};

// 页面加载完成后初始化
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        campaignPageAiPcNewArrivalModule.initVue();
        campaignPageAiPcNewArrivalModule.init();
    });
} else {
    campaignPageAiPcNewArrivalModule.initVue();
    campaignPageAiPcNewArrivalModule.init();
}

/**
 * 子分类标签左右切换功能
 */
document.addEventListener('DOMContentLoaded', function() {
    // 延迟执行，确保DOM完全渲染
    setTimeout(function() {
        initSubCategoryTabsSlider();
        initFourthCategoryTabsSlider();
    }, 300);
});

function initSubCategoryTabsSlider() {
    // 仅在移动端执行此函数（屏幕宽度小于等于 768px）
    if (window.innerWidth > 768) {
        return;
    }

    // 遍历所有子分类标签包装容器
    var subCategoryWrappers = document.querySelectorAll('.sub-category-tabs-wrapper');
    if (!subCategoryWrappers.length) return;

    subCategoryWrappers.forEach(function(wrapper) {
        var tabsContainer = wrapper.querySelector('.sub-category-tabs');
        if (!tabsContainer) return;

        var tabs = tabsContainer.querySelectorAll('.sub-tab-item');
        var prevBtn = wrapper.querySelector('.sub-category-prev');
        var nextBtn = wrapper.querySelector('.sub-category-next');

        if (!tabs.length) return;

        // 如果子分类数量少于等于2个,隐藏切换按钮并居中显示
        if (tabs.length <= 2) {
            wrapper.classList.add('show-less-than-3');
            return;
        }

        // 计算每个标签的宽度（包含gap）
        var tabWidth = 0;
        if (tabs.length > 0) {
            var firstTab = tabs[0];
            var tabStyle = window.getComputedStyle(firstTab);
            var marginLeft = parseFloat(tabStyle.marginLeft) || 0;
            var marginRight = parseFloat(tabStyle.marginRight) || 0;
            tabWidth = firstTab.offsetWidth + marginLeft + marginRight;
        }

        // 如果计算出的宽度为0，使用默认值
        if (tabWidth === 0) {
            tabWidth = 100; // 默认每个标签100px
        }

        // 固定一屏显示2个标签
        var visibleTabs = 2;
        var maxScroll = (tabs.length - visibleTabs) * tabWidth;

        // 当前滚动位置
        var currentScroll = 0;

        // 更新按钮状态
        function updateButtonStates() {
            if (currentScroll <= 0) {
                prevBtn.classList.add('disabled');
            } else {
                prevBtn.classList.remove('disabled');
            }

            if (currentScroll >= maxScroll - 1) { // 减1避免浮点数误差
                nextBtn.classList.add('disabled');
            } else {
                nextBtn.classList.remove('disabled');
            }
        }

        // 初始化按钮状态
        updateButtonStates();

        // 上一个按钮点击事件
        prevBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (currentScroll > 0) {
                currentScroll = Math.max(0, currentScroll - tabWidth);
                tabsContainer.style.transform = 'translateX(-' + currentScroll + 'px)';
                updateButtonStates();
            }
        });

        // 下一个按钮点击事件
        nextBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (currentScroll < maxScroll) {
                currentScroll = Math.min(maxScroll, currentScroll + tabWidth);
                tabsContainer.style.transform = 'translateX(-' + currentScroll + 'px)';
                updateButtonStates();
            }
        });
    });
}

function initFourthCategoryTabsSlider() {
    // 仅在移动端执行此函数（屏幕宽度小于等于 768px）
    if (window.innerWidth > 768) {
        return;
    }

    // 遍历所有第四层分类标签包装容器
    var fourthCategoryWrappers = document.querySelectorAll('.fourth-category-tabs');
    if (!fourthCategoryWrappers.length) return;

    fourthCategoryWrappers.forEach(function(wrapper) {
        // 防止重复初始化
        if (wrapper.hasAttribute('data-slider-initialized')) {
            return;
        }
        wrapper.setAttribute('data-slider-initialized', 'true');
        var tabsContainer = wrapper.querySelector('.fourth-category-tabs-inner');
        if (!tabsContainer) return;

        var tabs = tabsContainer.querySelectorAll('.fourth-tab-item');
        var prevBtn = wrapper.querySelector('.fourth-category-prev');
        var nextBtn = wrapper.querySelector('.fourth-category-next');

        if (!tabs.length) return;

        // 如果第四层分类数量少于等于2个,隐藏切换按钮并居中显示
        if (tabs.length <= 2) {
            wrapper.classList.add('show-less-than-3');
            return;
        }

        // 计算每个标签的宽度（包含gap）
        var tabWidth = 0;
        if (tabs.length > 0) {
            var firstTab = tabs[0];
            var tabStyle = window.getComputedStyle(firstTab);
            var marginLeft = parseFloat(tabStyle.marginLeft) || 0;
            var marginRight = parseFloat(tabStyle.marginRight) || 0;
            tabWidth = firstTab.offsetWidth + marginLeft + marginRight;
        }

        // 如果计算出的宽度为0，使用默认值
        if (tabWidth === 0) {
            tabWidth = 100; // 默认每个标签100px
        }

        // 固定一屏显示2个标签
        var visibleTabs = 2;
        var maxScroll = (tabs.length - visibleTabs) * tabWidth;

        // 当前滚动位置
        var currentScroll = 0;

        // 更新按钮状态
        function updateButtonStates() {
            if (currentScroll <= 0) {
                prevBtn.classList.add('disabled');
            } else {
                prevBtn.classList.remove('disabled');
            }

            if (currentScroll >= maxScroll - 1) { // 减1避免浮点数误差
                nextBtn.classList.add('disabled');
            } else {
                nextBtn.classList.remove('disabled');
            }
        }

        // 初始化按钮状态
        updateButtonStates();

        // 上一个按钮点击事件
        prevBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (currentScroll > 0) {
                currentScroll = Math.max(0, currentScroll - tabWidth);
                tabsContainer.style.transform = 'translateX(-' + currentScroll + 'px)';
                updateButtonStates();
            }
        });

        // 下一个按钮点击事件
        nextBtn.addEventListener('click', function(e) {
            e.preventDefault();
            if (currentScroll < maxScroll) {
                currentScroll = Math.min(maxScroll, currentScroll + tabWidth);
                tabsContainer.style.transform = 'translateX(-' + currentScroll + 'px)';
                updateButtonStates();
            }
        });
    });
}
